import React from 'react';
import PropTypes from 'prop-types';
import { Quote, Vehicle } from '@sm360/widget-commons-vehicle';
import URL from 'commons-garage/constants/url.js';
import config from 'commons-garage/config/index.js';
import 'commons-garage/components/GarageVehicle/GarageVehicle.scss';

const VehicleImage = ({ quote, vehicle }) => {
    const urlImg = vehicle.multimedia.getMainImage360x270() || quote.vehicle.multimedia.getMainImage360x270();
    const mainImageURL = urlImg || `${config.source.image}/ir/w360h270/images/${URL.NO_PHOTO}`;

    const vehicleNoPhotoBackground = !vehicle.multimedia.getMainImage360x270()
        ? 'no-photo has-secondary-background'
        : '';

    const vehicleImage = (
        <img className={vehicleNoPhotoBackground} alt={vehicle.getYearMakeModelTrim()} src={mainImageURL} />
    );

    const vehicleImageTile =
        quote.isQuoteInPending() || vehicle.isAvailable() ? (
            <a href={quote.getVDPUrl()}>{vehicleImage}</a>
        ) : (
            <span>{vehicleImage}</span>
        );

    return vehicleImageTile;
};

VehicleImage.propTypes = {
    quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired,
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModel).isRequired,
};

VehicleImage.displayName = 'VehicleImage';

export default VehicleImage;



// WEBPACK FOOTER //
// ./src/components/GarageVehicle/VehicleImageWrapper/VehicleImage/VehicleImage.jsx